var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { connect } from "@irati/store";
import Loading from "@irati/ui/src/Loading";
import { injectIntl } from "@irati/utils/lang";
import id from "@irati/utils/id";
import statementItemActions from "@irati/wallet/store/actions/StatementItem";
import NoData, { NoDataCTA } from "../NoData";
import StatementItemDetail from "./StatementItemDetail";
var PAGINATION_COUNT = 10;
var StatementItems = /** @class */ (function (_super) {
    __extends(StatementItems, _super);
    function StatementItems() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: null,
            canLoadMore: true,
            cursor: null
        };
        _this.getMoreItems = function (existingStatementItems, cursor) {
            var _a = _this.props.wallet, ownerUuid = _a.ownerUuid, uuid = _a.uuid;
            var list = _this.props.listStatementItems(existingStatementItems, ownerUuid, uuid, cursor, PAGINATION_COUNT).then(function (_a) {
                var newCursor = _a.newCursor;
                _this.setState({
                    canLoadMore: true,
                    cursor: newCursor
                });
            });
            _this.setState({
                load: list,
                canLoadMore: false
            });
        };
        _this.handleShowMoreClick = function () {
            var cursor = _this.state.cursor;
            if (cursor) {
                var results = _this.props.walletStatementItem.results;
                _this.getMoreItems(results, cursor);
            }
        };
        return _this;
    }
    StatementItems.prototype.componentDidMount = function () {
        if (this.props.wallet.uuid) {
            this.getMoreItems([], null);
        }
    };
    StatementItems.prototype.componentWillUnmount = function () {
        this.props.clearStatementItems();
    };
    StatementItems.prototype.componentDidUpdate = function () {
        if (this.props.wallet.uuid && !this.state.load) {
            this.getMoreItems([], null);
        }
    };
    StatementItems.prototype.render = function () {
        var _a = this.props, className = _a.className, results = _a.walletStatementItem.results, formatMessage = _a.formatMessage, isMobile = _a.isMobile;
        var _b = this.state, cursor = _b.cursor, load = _b.load, canLoadMore = _b.canLoadMore;
        if (!results) {
            return React.createElement(Loading, { load: this.state.load });
        }
        var hasData = results.length > 0;
        var idNamespace = id("statement-items", this.props);
        return (React.createElement("div", { className: className, id: idNamespace },
            hasData && (React.createElement(StatementItemDetail, { results: results, paginationCount: PAGINATION_COUNT, onShowMoreClick: this.handleShowMoreClick, load: load, canLoadMore: canLoadMore, id: idNamespace, cursor: cursor })),
            !hasData && (React.createElement(NoData, { useCardStyle: isMobile, id: idNamespace, text: formatMessage({ id: "wallet.noStatementItems.text" }) },
                React.createElement(NoDataCTA, null)))));
    };
    StatementItems.defaultProps = {
        className: null
    };
    return StatementItems;
}(PureComponent));
var mapState = function (_a) {
    var wallet = _a.wallet, walletStatementItem = _a.walletStatementItem, mq = _a.mq;
    return {
        wallet: wallet,
        walletStatementItem: walletStatementItem,
        isMobile: mq.lessThan.large
    };
};
var mapDispatch = {
    listStatementItems: function (existingStatementItems, walletOwnerId, walletId, cursor, limit) { return statementItemActions.list(existingStatementItems, walletOwnerId, walletId, cursor, limit); },
    clearStatementItems: statementItemActions.clear
};
export default injectIntl(connect(mapState, mapDispatch)(StatementItems));
